import { BoumRight } from '@moia-dev/moia-token-claims'

// ================================================================
// STOP NETWORK PERMISSIONS
// ================================================================
// Centralized permission constants for the stop-network library.
// Groups related BoumRight values by feature domain so they can be
// referenced from a single source of truth rather than scattered
// across individual component files.
//
// Usage with <Restricted>:
//   <Restricted requiredRights={[...STOP_CRUD_RIGHTS]}>
//
// Or use the useStopNetworkPermissions() hook for pre-computed booleans.

// ================================================================
// AREA ACCESS
// ================================================================

/** Required to access the Stop Network area at all */
export const AREA_ACCESS_RIGHTS = [BoumRight.AREA_STOP_NETWORK] as const

// ================================================================
// DASHBOARD
// ================================================================

/** Required to view the stop health dashboard */
export const DASHBOARD_READ_RIGHTS = [
  BoumRight.STOP_NETWORK_DASHBOARD_R,
] as const

// ================================================================
// STOPS
// ================================================================

/** Required to create, update, delete individual stops */
export const STOP_CRUD_RIGHTS = [BoumRight.SERVICE_AREA_STOP_CRUD] as const

/** Required to bulk-import stops */
export const STOP_BULK_CRUD_RIGHTS = [
  BoumRight.SERVICE_AREA_STOP_BULK_CRUD,
] as const

/** Required to view driver voting statistics on stops */
export const STOP_DRIVER_VOTING_RIGHTS = [
  BoumRight.SERVICE_AREA_STOP_DRIVER_VOTING,
] as const

// ================================================================
// AREAS
// ================================================================

/** Required to manage service areas (create, update, delete) */
export const AREA_CRUD_RIGHTS = [BoumRight.SERVICE_AREA_AREAS_CRUD] as const

// ================================================================
// ROAD BLOCKAGES
// ================================================================

/** Required to view road blockages */
export const ROAD_BLOCKAGE_READ_RIGHTS = [BoumRight.CSR_BLOCKED_ROAD_R] as const

/** Required to manage road blockages (create, update, delete) */
export const ROAD_BLOCKAGE_CRUD_RIGHTS = [
  BoumRight.CSR_BLOCKED_ROAD_CRUD,
] as const

// ================================================================
// TURN RESTRICTIONS
// ================================================================

/** Required to view turn restrictions */
export const TURN_RESTRICTION_READ_RIGHTS = [
  BoumRight.CSR_TURN_RESTRICTION_R,
] as const

/** Required to manage turn restrictions (create, update, delete) */
export const TURN_RESTRICTION_CRUD_RIGHTS = [
  BoumRight.CSR_TURN_RESTRICTION_CRUD,
] as const

// ================================================================
// LINE SERVICE
// ================================================================

/** Required to manage line services */
export const LINE_SERVICE_CRUD_RIGHTS = [
  BoumRight.STOP_NETWORK_LINE_SERVICE_CRUD,
] as const

/** Required to view line services */
export const LINE_SERVICE_READ_RIGHTS = [
  BoumRight.STOP_NETWORK_LINE_SERVICE_R,
] as const

/** Any line service access — used with allowedRights (OR logic) */
export const LINE_SERVICE_ANY_ACCESS_RIGHTS = [
  BoumRight.STOP_NETWORK_LINE_SERVICE_CRUD,
  BoumRight.STOP_NETWORK_LINE_SERVICE_R,
] as const

// ================================================================
// MAP CONTROLS (combined rights)
// ================================================================

/** Rights for the map edit toolbar (stop + area editing) */
export const MAP_EDIT_RIGHTS = [
  BoumRight.SERVICE_AREA_STOP_CRUD,
  BoumRight.SERVICE_AREA_AREAS_CRUD,
] as const
